export type PostEmployeeWorkTeamApiResponse =
  | /** status 200 Standard response */ ({
      workTeamId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostEmployeeWorkTeamApiArg = {
  body: {
    description: string;
    company: string;
    branch: string;
  } | null;
};
export type GetEmployeeWorkTeamApiResponse =
  | /** status 200 Standard response */ ({
      description?: string | null;
      company?: string | null;
      branch?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeWorkTeamApiArg = {
  /** Name */
  id: string;
};
export type DeleteEmployeeWorkTeamApiResponse = unknown;
export type DeleteEmployeeWorkTeamApiArg = {
  /** Name */
  id: string;
};
export type PatchEmployeeWorkTeamApiResponse = unknown;
export type PatchEmployeeWorkTeamApiArg = {
  /** Name */
  id: string;
  body: {
    description: string;
    company: string;
    branch: string;
  } | null;
};
export type GetEmployeeWorkTeamsListApiResponse =
  | /** status 200 Standard response */ ({
      workTeams?: ({
        id?: string | null;
        description?: string | null;
        branch?: string | null;
        company?: string | null;
        isActive?: boolean | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeWorkTeamsListApiArg = {
  /** GUID */
  company: string;
  /** GUID */
  branch: string;
};

export type PostEmployeeWorkTeamSetAsActiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeWorkTeamSetAsActiveApiArg = {
  workTeamId: string;
};
export type PostEmployeeWorkTeamSetAsInactiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeWorkTeamSetAsInactiveApiArg = {
  workTeamId: string;
};
